export default class LocationDeriver {
  static groupByParent(locations) {
    return locations
      .reduce((result, location) => {
        if (result[location.parent_id]) {
          result[location.parent_id].children.push(location);
        } else {
          result[location.parent_id] = {
            id: location.parent_id,
            name: location.parent_name,
            position: location.parent_position !== undefined ? location.parent_position : Number.MAX_SAFE_INTEGER,
            children: [location],
          };
        }

        return result;
      }, [])
      .sort((a, b) => a.position > b.position);
  }

  static addressRequirements(data) {
    return {
      address1: data.address_fields.address_line_1,
      address2: data.address_fields.address_line_2,
      city: data.address_fields.city,
      postalCode: data.address_fields.postal_code,
      state: data.address_fields.state_code,
    };
  }
}
